import React, { useEffect, useState } from "react";
import './AdminNavbar.css';
import { logOut } from "../../../features/redux/sessionSlice";
import { useDispatch, useSelector } from "react-redux";
import { getMyOffices, getLoadingMyOffices, getLoadingOfficeSessions, getOfficeSessions, setCurrentSessionId, getOfficeActiveSessionsAsync } from "../../../features/redux/appSlice";
import { useNavigate } from "react-router-dom";

function AdminNavbar({ activeTab, setActiveTab }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const offices = useSelector(getMyOffices);
    const sessions = useSelector(getOfficeSessions);
    const isLoadingOffices = useSelector(getLoadingMyOffices);
    const isLoadingSessions = useSelector(getLoadingOfficeSessions);
    const [officesOpen, setOfficesOpen] = useState(false);
    const [currentOffice, setCurrentOffice] = useState(null);

    useEffect(() => {
        if (currentOffice) {
            dispatch(getOfficeActiveSessionsAsync(currentOffice.id));
        }
    }, [currentOffice, dispatch]);

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <div className="btn-group btn-group-toggle" data-toggle="buttons">
                    <button onClick={() => { setActiveTab('users') }} className={`btn btn-outline-primary my-2 my-sm-0 ${activeTab === 'users' ? 'active' : ''}`} type="submit">
                        Users
                        {!isLoadingOffices && <i style={{ marginLeft: '4px' }} className="fa-solid fa-user"></i>}
                        {isLoadingOffices && <i style={{ marginLeft: '4px' }} className="fa fa-circle-notch fa-spin"></i>}
                    </button>
                    <button onClick={() => { setActiveTab('offices') }} className={`btn btn-outline-primary my-2 my-sm-0 ${activeTab === 'offices' ? 'active' : ''}`} type="submit">
                        Offices
                        {!isLoadingOffices && <i style={{ marginLeft: '4px' }} className="fa-solid fa-building"></i>}
                        {isLoadingOffices && <i style={{ marginLeft: '4px' }} className="fa fa-circle-notch fa-spin"></i>}
                    </button>
                    <button onClick={() => { setActiveTab('doors') }} className={`btn btn-outline-primary my-2 my-sm-0 ${activeTab === 'doors' ? 'active' : ''}`} type="submit">
                        Doors
                        {!isLoadingOffices && <i style={{ marginLeft: '4px' }} className="fa-solid fa-door-open"></i>}
                        {isLoadingOffices && <i style={{ marginLeft: '4px' }} className="fa fa-circle-notch fa-spin"></i>}
                    </button>
                    <button onClick={() => { setActiveTab('homeAssistants') }} className={`btn btn-outline-primary my-2 my-sm-0 ${activeTab === 'homeAssistants' ? 'active' : ''}`} type="submit">
                        Home Assistants
                        {!isLoadingOffices && <i style={{ marginLeft: '4px' }} className="fa-solid fa-house-user"></i>}
                        {isLoadingOffices && <i style={{ marginLeft: '4px' }} className="fa fa-circle-notch fa-spin"></i>}
                    </button>
                </div>
               
                <div className="btn-group btn-group-toggle" data-toggle="buttons">
                    <button className="btn btn-outline-success my-2 my-sm-0" onClick={() => { navigate('/dashboard') }} type="submit">Office Manager Dashboard</button>
                    <button className="btn btn-outline-danger my-2 my-sm-0" onClick={() => { dispatch(logOut()) }} type="submit">Log Out</button>
                </div>
            </div>
        </nav>
    );
}

export default AdminNavbar;
